var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m113.442 182.615a16 16 0 0 1 16-16h128.749a16 16 0 0 1 0 32h-128.749a16 16 0 0 1 -16-16zm0 220.157a16 16 0 0 0 16 16h232.686a16 16 0 0 0 0-32h-232.686a16 16 0 0 0 -16 16zm0-110.079a16 16 0 0 0 16 16h166.767a16 16 0 1 0 0-32h-166.767a16 16 0 0 0 -16 16zm363.876-116.048v319.355a16 16 0 0 1 -16 16h-410.636a16 16 0 0 1 -16-16v-480a16 16 0 0 1 16-16h243.871a16 16 0 0 1 11.1 4.477l166.765 160.645a16 16 0 0 1 4.9 11.523zm-166.765-16h111.093l-111.093-107.016zm134.765 32h-150.765a16 16 0 0 1 -16-16v-144.645h-211.871v448h378.636z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument01);
export default __webpack_public_path__ + "static/media/document-01.2f1e42892368ca26ea78e08568c75948.svg";
export { ForwardRef as ReactComponent };